import Guard from "../../guard";
import { IDirtyTracking } from "../dirty-tracking/dirty-tracking";
import { MemberDefinitionType } from "./member-definition-type";

/**
 * Base interface for all members (properties and relations).
 */
export interface IMember extends IDirtyTracking {
    /**
     * {@link MemberDefinition}
     */
    name: string;

    /**
     * The {@link MemberDefinitionType} of the member definition.
     */
    definitionType: MemberDefinitionType;
}

export abstract class MemberBase implements IMember {
    name: string;
    isTracking: boolean;
    readonly definitionType: MemberDefinitionType;
    abstract readonly isDirty: boolean;
    abstract startTracking(): void;
    abstract markClean(): void;

    constructor(name: string, definitionType: MemberDefinitionType) {
        Guard.stringNotNullOrEmpty(name);

        this.name = name;
        this.definitionType = definitionType;
    }

    /**
     * Returns a string representation of the current member instance.
     *
     * @remarks
     * Can not be used for serialization. Only useful during debugging or testing.
     * Returned format: \<member name\> ({@link MemberDefinitionType}) (\<constructor.name\>)
     */
    toString(): string {
        return `${this.name} (${MemberDefinitionType[this.definitionType]}) (${this.constructor.name})`;
    }
}
